module.exports = __webpack_public_path__ + "img/77402.b6e4f0b0.svg";